/**
 * The place where most of the custom JavaScript should be found.
 */
import { vw } from '../inc/global';
import A11yDialog from 'a11y-dialog';

/**
 * Prime latest products with glide structure
 */
 ;(() => {
    if( ! document.querySelector( '.latest-products' ) ) return

    const latestProducts = document.querySelectorAll( '.latest-products' );

    latestProducts.forEach(element => {
        
        const track = element.querySelector( '.woocommerce' )
        const productsList = element.querySelector( 'ul.products' )
        const products = element.querySelectorAll( 'li.product' )
    
        track.classList.add( 'glide__track' )
        track.setAttribute( 'data-glide-el', 'track' )
        productsList.classList.add( 'glide__slides' )


        products.forEach(product => {
            product.classList.add('glide__slide')
        });
    });
})();

/**
 * Scroll to top!
 */
 ;( () => {
    const scrollTopTrigger = document.getElementById( 'back-to-top' )

    if ( ! scrollTopTrigger ) return

    scrollTopTrigger.addEventListener( 'click', e => {

        if ( ! 'scrollBehavior' in document.documentElement.style ) {
            e.preventDefault()

            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        }
    })
})();

/**
 * Actions bar
 */
 ;( () => {
    const actionsBar = document.querySelector( '.actions-bar' )
    if ( ! actionsBar ) return

    const toggleWrapper = actionsBar.querySelector( 'div.toggles' )
    const searchPanel = actionsBar.querySelector( '[data-action-panel="search"]' )
    let currAction

    const actionPaths = {
        contact: '/contact-us/'
    }

    function closeActionsBar() {
        actionsBar.classList.remove( 'is-active', `${ currAction }-is-active` )
        currAction = false

        window.removeEventListener( 'scroll', closeActionsBar )
    }

    toggleWrapper.addEventListener( 'click', e => {
        if ( e.target.nodeName !== 'BUTTON' ) return

        const action = e.target.dataset.action

        if ( vw() >= 768 ) {

            switch ( action ) {
                case 'back-to-top':
                    document.querySelector( '#back-to-top' ).click()
                    break
                case 'search':
                    const qSearchForm = document.forms['quick-search'] && document.forms['quick-search']

                    if ( qSearchForm.s.value !== '' ) {
                        qSearchForm.submit()
                    }

                    break
                default:
                    window.location.href = window.location.origin + actionPaths[ action ]
            }

        } else {
            if ( action === currAction ) {
                closeActionsBar()
    
                return
            }
    
            actionsBar.classList.remove( `${ currAction }-is-active` )
            actionsBar.classList.add( 'is-active', `${ action }-is-active` )
    
            currAction = action
            window.addEventListener( 'scroll', closeActionsBar )
        }
    })

    let removeOpen

    function toggleMouseOverSearch() {
        clearTimeout( removeOpen )
    }

    function toggleMouseOver( e ) {
        if ( e.target.nodeName !== 'BUTTON' ) return

        const action = e.target.dataset.action

        actionsBar.classList.remove( `${ currAction }-is-hovered` )
        actionsBar.classList.add( 'is-hovered', `${ action }-is-hovered` )

        if ( action === 'search' ) {
            clearTimeout( removeOpen )
        }

        currAction = action
    }

    function toggleMouseMove( e ) {
        if ( e.target.nodeName !== 'BUTTON' ) return

        const action = e.target.dataset.action

        if ( action !== currAction ) {
            actionsBar.classList.remove( 'is-hovered', `${ currAction }-is-hovered` )
            actionsBar.classList.add( 'is-hovered', `${ action }-is-hovered` )
        }

        currAction = action
    }

    function toggleMouseLeave( e ) {

        if ( currAction !== 'search' ) {
            actionsBar.classList.remove( 'is-hovered', `${ currAction }-is-hovered` )
            currAction = false

        } else {
            removeOpen = setTimeout( () => {
                actionsBar.classList.remove( 'is-hovered', `${ currAction }-is-hovered` )
                currAction = false

            }, 200 )
        }
    }

    function updateActionEventListeners( method = 'add' ) {
        toggleWrapper[ `${ method }EventListener` ]( 'mouseover', toggleMouseOver )
        toggleWrapper[ `${ method }EventListener` ]( 'mousemove', toggleMouseMove )
        toggleWrapper[ `${ method }EventListener` ]( 'mouseleave', toggleMouseLeave )

        searchPanel[ `${ method }EventListener` ]( 'mouseover', toggleMouseOverSearch )
        searchPanel[ `${ method }EventListener` ]( 'mouseleave', toggleMouseLeave )
    }

    const query = 768
    if ( window.innerWidth >= query ) {
        updateActionEventListeners()
    }
    
    window.matchMedia( `(min-width: ${ query }px)` ).addListener( e => {
        updateActionEventListeners( e.matches ? 'add' : 'remove' )
    })
})();


/**
 * WooCommerce 
 */
( () => {
    const form = document.forms.filter_attributes
    const fieldsets = form?.querySelectorAll( 'fieldset' )

    if ( !form ) {
        return
    }

    form.addEventListener( 'change', () => {
        const mainAttributes = [
            {
                name: 'material',
                value: null
            },
            {
                name: 'colour',
                value: null
            },
            {
                name: 'applications',
                value: null
            }
        ]

        /**
         * Find a match for a main attribute, and set the value.
         * 
         * @param {string} currentAttribute The attribute name
         * @param {string|null} value Value from FormData entry
         * @returns {object|null}
         */
        function findAttributeMatch( currentAttribute, value ) {
            return mainAttributes.find( attribute => {
                if ( attribute.name === currentAttribute ) {
                    if ( attribute.value ) {
                        attribute.value = [ attribute.value, value ]
                    } else {
                        attribute.value = value
                    }
                }

                return attribute.name === currentAttribute
            })
        }

        const data = new FormData( form )
        const targetUrl = new URL( '/our-stones/', location.origin )

        for ( const [ key, value ] of data.entries() ) {
            const attribute = key.replace( /^filter_/, '' )

            if ( !findAttributeMatch( attribute, value ) ) {
               targetUrl.searchParams.set( key, value )
            }
        }

        const urlSegments = mainAttributes.filter( attribute => {
            if ( Array.isArray(attribute.value) ) {
                targetUrl.searchParams.set( `filter_${ attribute.name }`, attribute.value.join( ',' ) )
            }

            return typeof attribute.value === 'string'
        })

        if ( urlSegments.length ) {
            targetUrl.pathname = `/our-stones/${ urlSegments.map( segment => segment.value ).join( '/' ) }/`
        }

        window.location = targetUrl
    })

    /**
     * Toggle attributes display.
     */
    fieldsets.forEach( fieldset => {
        const button = fieldset.querySelector( 'button' )
        const filterOptionsWrapper = fieldset.querySelector( '.filter-options' )

        button.addEventListener( 'click', event => {
            const action = fieldset.classList.contains( 'options-hidden' ) ? 'remove' : 'add'

            fieldset.classList[ action ]( 'options-hidden' )
        })
    })


    /**
     * Scroll.
     */
    const scrollFades = [
        form.querySelector( '.shiftr-wc-filter__scroll__fade--top' ),
        form.querySelector( '.shiftr-wc-filter__scroll__fade--bottom' )
    ]

    let options = {
        root: form.querySelector( '.shiftr-wc-filter__scroll' ),
        rootMargin: '0px',
        threshold: 1.0
    }

    let firstScrollDone = false
    let firstFieldset = fieldsets[0]
    let lastFieldset = fieldsets[fieldsets.length - 1]

    function showFaders() {
        scrollFades.forEach( element => element.classList.remove( 'hide' ) )
    }

    function hideFaders() {
        scrollFades.forEach( element => element.classList.add( 'hide' ) )
    }

    function callback( entries, observer ) {
        console.log( entries.length )

        entries.forEach( ( entry, index ) => {
            entry.target.isIntersecting = entry.isIntersecting

            if ( entry.isIntersecting ) {
                hideFaders()
            } else if ( firstScrollDone && !firstFieldset?.isIntersecting ) {
                showFaders()
            }

            if ( !firstScrollDone && index === 1 && !entry.isIntersecting ) {
                firstScrollDone = true
            }
        })
    }
      
    const observer = new IntersectionObserver( callback, options )

    ;[ firstFieldset, lastFieldset ]?.forEach( fieldset => {
        observer.observe( fieldset )
    })
})();

/**
 * Product Filter Search.
 */
( () => {
    const form = document.forms['product-attribute-search']

    if ( !form ) {
        return
    }

    form.addEventListener( 'submit', event => {
        event.preventDefault()

        const urlSegments = []
        /**
         * Couldn't get an array of the elements to work for some reason,
         * so here's the long winded way...
         */
        const material = form.querySelector( 'select[name="pa_material"]' )
        const colour = form.querySelector( 'select[name="pa_colour"]' )
        const application = form.querySelector( 'select[name="pa_applications"]' )

        if (material.value !== '0') {
            urlSegments.push(material.value)
        }

        if (colour.value !== '0') {
            urlSegments.push(colour.value)
        }

        if (application.value !== '0') {
            urlSegments.push(application.value)
        }

        location.href = new URL( `/our-stones/${ urlSegments.join( '/' ) }/`, location.origin )
    })
})();


/**
 * Quote form dialog.
 */

const container = document.getElementById('quote_form')
const dialog = new A11yDialog(container)

dialog
  .on('show', () => (document.documentElement.style.overflowY = 'hidden'))
  .on('hide', () => (document.documentElement.style.overflowY = ''))



/**
 * Shop filter mobile menu.
 */

const filterButton = document.getElementById('shiftr-wc-filter-trigger');
const filterForm = document.querySelector('form.shiftr-wc-filter');
const filterClose = document.getElementById('shiftr-wc-filter-close');
const overlay = document.getElementById('shiftr-wc-filter-overlay');

function closeFilterMenu() {
    filterForm.dataset.state = 'closed';
    document.body.classList.remove('shiftr-wc-filter-overlay-active');
    overlay.removeEventListener('click', closeFilterMenu);
}

if (filterButton && filterForm) {
    filterClose.addEventListener('click', closeFilterMenu);
    filterButton.addEventListener('click', () => {
        filterForm.dataset.state = 'open';
        document.body.classList.add('shiftr-wc-filter-overlay-active');
        overlay.addEventListener('click', closeFilterMenu);
    });
}

/**
 * Product quote form.
 */
;(() => {
    const form = document.querySelector('div.product form.shiftr-form')

    if ( !form ) {
        return
    }

    const productField = form.querySelector('.field-product input')
    productField.value = document.querySelector('h1').textContent
    productField.readOnly = true

    form.querySelector('.field-autofill-thickness select').innerHTML = productThicknessOptions?.sort((a,b) => {
        const aN = Number(a.replace(/mm/, ''))
        const bN = Number(b.replace(/mm/, ''))

        return aN - bN
    }).map(thickness => `
        <option>${thickness}</option>
    `).join('')
})();

/**
 * Announcement Bar
 */
;( () => {
    const banner = document.querySelector( '.announcement-bar' )
    const cookieName = 'announcement_bar_state'

    if ( !banner ) {
        return
    }

    if ( document.cookie.indexOf( cookieName ) > 0 ) {
        return
    }

    banner.classList.remove( 'is-hidden' )
    banner.setAttribute( 'aria-hidden', false )
    document.body.classList.add( 'announcement-bar-active' )

    function closeBanner( event ) {
        event.preventDefault()
        banner.classList.add( 'is-hidden' )
        banner.setAttribute( 'aria-hidden', true )
        document.body.classList.remove( 'announcement-bar-active' )

        const expiry = new Date()
        expiry.setDate( expiry.getDate() + 7 )
        document.cookie = `${cookieName}=hidden; expires=` + expiry + '; path=/'
    }

    banner.querySelector( 'button.banner-close' ).addEventListener( 'click', closeBanner )
})();

/**
 * Quote form
 */
(() => {
    ['_20204_product', '_22229_product'].forEach((name) => {
        document.getElementsByName(name)?.forEach((el) => {
            el.placeholder = 'Select your product by searching here'
        })
    })

    const radio1s = document.querySelectorAll('[data-shiftr-form="quote"] .radio-stone-info-selector-stone input')
    const radio1 = radio1s[0]
    const radio2 = document.querySelector('[data-shiftr-form="quote"] .radio-stone-info-selector-recommendation input')
    const fieldset1 = document.querySelector('#fieldset_stone')
    const fieldset2 = document.querySelector('#fieldset_recommendation')

    if (!radio1) {
        return
    }

    radio1s.forEach(radio => {
        radio.checked = true
    })

    function updateFieldset() {
        fieldset1.disabled = radio2.checked
        fieldset2.disabled = radio1.checked
    }

    updateFieldset()
    radio1.addEventListener('change', updateFieldset)
    radio2.addEventListener('change', updateFieldset)
})();

/**
 * Quote form
 */
document.addEventListener('DOMContentLoaded', function () {

    const recommendationFieldset = document.getElementById('fieldset_recommendation');
    if (!recommendationFieldset) return;

    function scrollToElement(el, offset = 20) {
        const dialogContainer = el.closest('.dialog-container');
        if (dialogContainer) {
            const elRect = el.getBoundingClientRect();
            const containerRect = dialogContainer.getBoundingClientRect();
            const scrollTop = dialogContainer.scrollTop + (elRect.top - containerRect.top) - offset;
            dialogContainer.scrollTo({ top: scrollTop, behavior: 'smooth' });
        }
    }

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'disabled' && !recommendationFieldset.disabled) {
                scrollToElement(recommendationFieldset);
            }
        });
    });

    observer.observe(recommendationFieldset, {
        attributes: true,
        attributeFilter: ['disabled']
    });

});